/**
 * @generated SignedSource<<6b4d55f94e47daa5b71c85fc7200de1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuoteProviderMarkEvaluationRequestedMutation$variables = {
  quoteId: string;
};
export type QuoteProviderMarkEvaluationRequestedMutation$data = {
  readonly markEvaluationRequested: {
    readonly evaluationRequestedAt: any | null;
    readonly id: string;
  } | null;
};
export type QuoteProviderMarkEvaluationRequestedMutation = {
  response: QuoteProviderMarkEvaluationRequestedMutation$data;
  variables: QuoteProviderMarkEvaluationRequestedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "quoteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "quoteId",
        "variableName": "quoteId"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "markEvaluationRequested",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "evaluationRequestedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderMarkEvaluationRequestedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderMarkEvaluationRequestedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e8f96a3b0a9fed371e8c135925f4492",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderMarkEvaluationRequestedMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderMarkEvaluationRequestedMutation(\n  $quoteId: ID!\n) {\n  markEvaluationRequested(quoteId: $quoteId) {\n    id\n    evaluationRequestedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebcf414574f78a6d6ef864c479ca02cb";

export default node;
